import React from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { XCircle, ArrowLeft, RefreshCw } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Card, CardContent } from '../components/ui/card';

const CheckoutErrorPage = () => {
  const [searchParams] = useSearchParams();
  const message = searchParams.get('message') || 'Ödeme işlemi sırasında bir hata oluştu.';

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center" data-testid="checkout-error-page">
      <Card className="w-full max-w-md mx-4">
        <CardContent className="p-8 text-center">
          <div className="w-20 h-20 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-6">
            <XCircle className="h-12 w-12 text-red-600" />
          </div>
          <h2 className="text-2xl font-bold text-slate-900 mb-2">Ödeme Başarısız</h2>
          <p className="text-slate-500 mb-6">{decodeURIComponent(message)}</p>

          <div className="space-y-3">
            <Link to="/cart">
              <Button className="w-full bg-orange-500 hover:bg-orange-600">
                <RefreshCw className="h-5 w-5 mr-2" />
                Tekrar Dene
              </Button>
            </Link>
            <Link to="/products">
              <Button variant="outline" className="w-full">
                <ArrowLeft className="h-5 w-5 mr-2" />
                Alışverişe Devam Et
              </Button>
            </Link>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default CheckoutErrorPage;
